<template>
  <div class="course">
    <div class="course-serach">
      <div class="course-serach-left">
        <div>
          <span>课程名称：</span>
          <el-input
            v-model="name"
            placeholder="请输入课程名称"
          />
        </div>
        <div>
          <span>主讲科目：</span>
          <el-input
            v-model="subject"
            placeholder="请输入科目名称"
          />
        </div>
      </div>
      <div class="course-serach-right">
        <el-button
          type="primary"
          size="small"
          @click="search"
        >查 询</el-button>
        <el-button
          plain
          size="small"
          @click="reset"
        >重 置</el-button>
        <el-button
          plain
          size="small"
          :loading="loading"
          @click="exportExcel"
        >导 出</el-button>
      </div>
    </div>
    <div class="course-table">
      <el-table
        :data="videoCourseList"
        border
        stripe
        :header-cell-style="{ background: '#fafafa' }"
        style="width: 100%"
      >
        <el-table-column
          label="序号"
          type="index"
          width="50"
          align="center"
        />
        <el-table-column
          prop="name"
          label="课程名称"
          show-overflow-tooltip
        />
        <el-table-column
          prop="decode"
          label="课程校验码"
        />
        <el-table-column
          prop="des"
          label="课程简介"
          show-overflow-tooltip
        />
        <el-table-column
          prop="teacherName"
          label="主讲老师"
          show-overflow-tooltip
        />
        <el-table-column
          prop="subject"
          label="主讲科目"
          show-overflow-tooltip
        />
        <el-table-column
          prop="updateTime"
          label="上传日期"
          show-overflow-tooltip
        />
        <el-table-column
          prop="deadline"
          label="截至日期"
          show-overflow-tooltip
        />
        <el-table-column label="上传人">
          <span>管理员</span>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleClickUpdate(scope.row)"
            >修改</el-button>
            <el-button
              type="text"
              size="small"
              @click="jumpRecord(scope.row)"
            >课程观看记录</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleClickDel(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="course-pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="page"
        :total="total"
        :page-size="size"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getCourseList, getDelCourse } from "@/api/course";
import { downLoadFile } from "@/utils/downLoad";
export default {
  data() {
    return {
      name: "",
      subject: "",
      page: 1,
      size: 10,
      videoCourseList: [],
      total: 0,
      loading: false
    };
  },
  mounted() {
    this.getCourseList();
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.getCourseList();
    },
    // 修改
    handleClickUpdate(val) {
      this.$router.push({
        path: "/courseUpload",
        query: {
          data: JSON.stringify(val)
        }
      });
    },
    handleClickDel(val) {
      this.$confirm("此操作将删除该课程, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.getDelCourse(val.id);
      });
    },
    jumpRecord(val) {
      this.$router.push({
        path: "/courseManage/courseRecord",
        query: {
          data: JSON.stringify(val)
        }
      });
    },
    search() {
      this.page = 1;
      this.getCourseList();
    },
    reset() {
      this.page = 1;
      this.name = "";
      this.subject = "";
      this.getCourseList();
    },
    exportExcel() {
      this.loading = true;
      let data = {
        name: this.name,
        subject: this.subject
      };
      axios({
        method: "post",
        url: `${process.env.VUE_APP_URL}/video-course/api/course/export`,
        data,
        responseType: "blob"
      }).then(res => {
        let name = "课程信息汇总表";
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(res.data, `${name}.xlsx`);
        } else {
          downLoadFile(res.data, name);
        }
        this.loading = false;
      });
    },
    getCourseList() {
      let data = {
        name: this.name,
        page: this.page,
        size: this.size,
        subject: this.subject
      };
      getCourseList(data).then(res => {
        this.videoCourseList = res.videoList;
        this.total = res.total;
      });
    },
    getDelCourse(id) {
      getDelCourse({ id: id }).then(res => {
        this.$message.success(res);
        this.getCourseList();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.course {
  padding: 20px 15% 40px 15%;
  &-serach {
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    &-left {
      display: flex;
      > div {
        display: flex;
        align-items: center;
        > span {
          width: 120px;
        }
        ::v-deep.el-input__inner {
          height: 32px;
          width: 240px;
        }
      }
    }
  }
  &-table {
    margin-top: 20px;
    border: 1px solid #ccc;
  }
  &-pagination {
    padding: 40px 0;
    text-align: center;
  }
}
</style>


